export enum TicketMemberField {
	Name = 0,
	Company = 1,
	Email = 2,
	Phone = 3,
	JobTitle = 4,
	MobilePhone = 5,
	ShippingAddress = 6,
	Credentials = 7
}